export enum RoleUserEnum {
  ADMIN = 'ADMIN',
  SUPERVISOR = 'SUPERVISOR',
  ATTENDANT = 'ATTENDANT',
}